<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="380px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">

                    <el-form-item  label="目录名称" v-if="isIndicatorsList">
                        <el-input v-model="form.title" maxlength="50" style="width:200px;"></el-input>
                    </el-form-item>

                    <el-form-item  label="指标名称" v-if="!isIndicatorsList">
                        <el-input v-model="form.title" maxlength="50" style="width:200px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="evaluateTypeId" label="绑定维度" v-if="!isIndicatorsList">
                        <el-select v-model="form.evaluateTypeId" clearable>
                            <el-option
                                v-for="item in evaluateTypes"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item   prop="type" label="评价类型" v-if="!isIndicatorsList">
                        <el-select v-model="form.type" clearable>
                            <el-option
                                v-for="item in types"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item  prop="score" label="分值" v-if="!isIndicatorsList">
                        <el-input v-model="form.score" maxlength="20" type="number" style="width:200px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="iconUrl" label="奖章图标" v-if="!isIndicatorsList">
                        <el-select v-model="form.iconUrl"  clearable placeholder="请选择" style="width:200px;">
                            <el-option
                                v-for="item in icons"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item  prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="20" type="number" style="width:200px;"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                loading:false,
                visible: false,
                isIndicatorsList:true,
                form:{
                    id:"",
                    deptId:"",
                    parentId:"",
                    evaluateTypeId:"",
                    title:"",
                    type:"",
                    iconUrl:"",
                    score:"",
                    orderNum:""
                },
                indicatorsTypes:[{
                    value: 1,
                    label: '目录'
                },{
                    value: 2,
                    label: '指标'
                }],
                types:[{
                    value: 1,
                    label: '表扬'
                },{
                    value: 2,
                    label: '待改进'
                }],
                rules: {
                    evaluateTypeId: [
                        { required: true, message: '请选择五育类型', trigger: 'blur' }
                    ],
                    type: [
                        { required: true, message: '请选择评价类型', trigger: 'blur' }
                    ],
                    score: [
                        { required: true, message: '请输入分值', trigger: 'blur' }
                    ]
                },
                evaluateTypes:[],
                icons:[]
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                // 初始值
                this.form.id=data.id;
                this.form.title=data.text;
                this.form.evaluateTypeId=data.attributes.evaluateTypeId;
                this.form.type=data.attributes.type;
                this.form.deptId=data.attributes.deptId;
                this.form.iconUrl=data.attributes.iconUrl;
                this.form.score=data.attributes.score;
                this.form.orderNum=data.attributes.orderNum;

                // 如果是指标类型是目录，那么只修改目录，其他隐藏
                // 指标类型（1-目录 ， 2-指标）
                if(data.attributes.indicatorsType == 1){
                    this.isIndicatorsList=true;
                }else if(data.attributes.indicatorsType == 2){
                    this.isIndicatorsList=false;
                }
                // 加载五育数据
                this.getEvaluateType();
                // 获取奖章图标
                this.getIcon();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getEvaluateType(){
                let url  = this.evaluateTypeListTypeUrl;
                let data = {
                    deptId:this.form.deptId
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.evaluateTypes = res.data.list;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getIcon(){
                //部门管理
                let url  = this.listDictUrl;
                let data = {
                    name:"MEDAL_KEY",
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.icons=res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            changeIndicators(){
                // 指标类型（1-目录 ， 2-指标）
                if(this.form.indicatorsType == 1){
                    this.isIndicatorsList=true;
                }else if(this.form.indicatorsType == 2){
                    this.isIndicatorsList=false;
                }
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        // isIndicatorsList：true-目录名称，false-指标名称
                        if(this.isIndicatorsList){
                            if(this.form.title == ''){
                                this.$commonFn.showTip('请输入目录名称',3);
                                return;
                            }
                        }else{
                            if(this.form.title == ''){
                                this.$commonFn.showTip('请输入指标名称',3);
                                return;
                            }
                        }
                        
                        let url= this.evaluateIndicatorsDefineUpdateUrl;
                        let data = {
                            id:this.form.id,
                            evaluateTypeId:this.form.evaluateTypeId,
                            title:this.form.title,
                            type:(this.form.type==null?"":this.form.type),
                            iconUrl:this.form.iconUrl,
                            score:(this.form.score==null?"":this.form.score),
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.loading=true;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/UpdateIndicators.vue